/* eslint-disable react-hooks/exhaustive-deps */
import "./style.css";
import { useState, useEffect } from "react";
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import anime from "animejs";
import arrow from "../../Images/icon/arrow.png";
import ScrollToTop from "../../Components/scrollup";
import ScrollPage from "../../Components/scrollpageUp";
import { Icons } from "../../Data/cardData";
import SignpostIcon from "@mui/icons-material/SignpostOutlined";
import Footer from "../../Components/Footer";

const customTheme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 600, md: 1080, lg: 1280 },
  },
  palette: {
    primary: {
      main: "#00897b",
      light: "#80cbc4",
      dark: "#00695c",
      contrastText: "#fff",
    },
  },
});

export default function ProduitsFamilles() {
  const [path1, setPath1] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // ✅ On récupère uniquement le premier segment (ex: /nos produits/Fenêtres)
  useEffect(() => {
    const pathName = decodeURIComponent(window.location.pathname);
    const segments = pathName.split("/");
    setPath1(segments[2] || "");
  }, []);

  // ✅ Animation d’apparition
  useEffect(() => {
    const timer = setTimeout(() => {
      const elements = document.querySelectorAll(".gammeDiv:not(.vide)");
      anime({
        targets: elements.length > 0 ? elements : ".gammeDiv",
        translateX: [400, 0],
        opacity: [0, 1],
        scale: [0, 1],
        delay: anime.stagger(200, { start: 300 }),
        easing: "easeInOutQuad",
      });
    }, 0);

    return () => clearTimeout(timer);
  }, [path1, Icons]);

  return (
    <ThemeProvider theme={customTheme}>
      <div className="home">
        <ScrollToTop />
        <ScrollPage />

        {/* ✅ Image de couverture */}
       

        {/* ✅ Liste des produits */}
        <div className="homeGamme">
          <h1>{path1}</h1>
          <div>
            {Icons.map((icon) =>
              icon.nom === path1 ? (
                icon.pics.map((item, idx) => (
                  <div
                    key={idx}
                    className="gammeDiv"
                    onMouseEnter={() => setHoveredIndex(idx)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <div className="linkItems">
                      <div>
                        <img
                          src={`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2Fproduits%2F${encodeURIComponent(
                            path1
                          )}%2F${encodeURIComponent(item.nom)}.jpg?alt=media`}
                          alt={item.nom}
                          className="gammeImg"
                        />
                      </div>
                      {item.projet?(
                          <a href={`/${item.projet}`}>
                      <span className="gammeName">
                      
                      
                            <SignpostIcon
                              fontSize="small"
                              sx={{ marginRight: 1 }}
                            />
                            {item.projet}
                     
                      
                     
                      </span>
                         <img
                          src={arrow}
                          alt="arrow"
                          className={
                            hoveredIndex === idx ? "rowIcon" : "rowIcon hover"
                          }
                        />
                      </a>):(<></>)}
                    </div>
                  </div>
                ))
              ) : null
            )}
          </div>
        </div>

        <Footer />
      </div>
    </ThemeProvider>
  );
}
